import { isServer } from '@flipster/utils/env-helper';

import { enabledPrexDevTool } from '../prex-dev-tool';

export const isOverrideEnabled = !isServer && enabledPrexDevTool();
export type Flags = Record<string, boolean>;
const flags: Flags = {};

// prefix: squad name
// example key: OE_tiered_max_oi
// vvv-- define your feature flags here --vvv

export const customVaraFlag = defineFlag('FE_custom_vara', false);
export const r230522NormalSubFlag = defineFlag('FE_r230522_normal_sub', true);
export const tieredMaxOiFlag = defineFlag('OE_tiered_max_oi', true);

// ^^^-- define your feature flags here --^^^

export function getFlags(): Flags {
  return { ...flags };
}
export function updateFlagsAndReload(newFlags: Flags): void {
  if (!isOverrideEnabled) return;
  Object.entries({ ...flags, ...newFlags }).forEach(([key, value]) => {
    sessionStorage.setItem(getStorageKey(key), String(value));
  });
  location.reload();
}

function getStorageKey(key: string): string {
  return `flipster.custom_flag.${key}`;
}

type GetFlagFn = () => boolean;
function defineFlag(key: string, defaultValue: boolean): GetFlagFn {
  if (!isOverrideEnabled) {
    flags[key] = defaultValue;
    return () => defaultValue;
  }
  const storageValue = sessionStorage.getItem(getStorageKey(key));
  const initialValue = storageValue == null ? defaultValue : storageValue === 'true';
  flags[key] = initialValue;
  return () => flags[key];
}
